module.exports = __webpack_public_path__ + "img/8ac28c6.png";